<template>
  <div class="col d-flex justify-content-center">
    <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
      <div class="btn-group" role="group" aria-label="First group">
        <button type="button" class="btn btn-primary" @click="onFirstPage" :class="[isCurrentPage(1) ? 'disabled' : '']" v-if="$mq !== 'mobile'">
          <i class="ion-ios-arrow-back arrow-back"></i><i class="ion-ios-arrow-back arrow-back"></i>
        </button>
        <button type="button" class="btn btn-primary" @click="onPreviousPage" :class="[isCurrentPage(1) ? 'disabled' : '']">
          <i class="ion-ios-arrow-back arrow-back"></i>
        </button>
        <button type="button" class="btn btn-primary" v-for="n in range(pageStart, pageEnd)" @click="onChangePage(n)" :class="[isCurrentPage(n) ? 'focus' : '']">{{ n }}</button>
        <button type="button" class="btn btn-primary" @click="onNextPage" :class="[isCurrentPage(pages) ? 'disabled' : '']">
          <i class="ion-ios-arrow-forward arrow-forward"></i>
        </button>
        <button type="button" class="btn btn-primary" @click="onLastPage" :class="[isCurrentPage(pages) ? 'disabled' : '']" v-if="$mq !== 'mobile'">
          <i class="ion-ios-arrow-forward arrow-forward"></i><i class="ion-ios-arrow-forward arrow-forward"></i>
        </button>
      </div>
    </div>
    <div>
      <input type="text" v-bind:value="perPage" v-on:input="perPageChange" class="pagination-input" /><span  v-if="$mq !== 'mobile'"> Per page</span>
    </div>
    <div class="pagination-status"  v-if="$mq === 'desktop' || $mq === 'laptop'">
      {{ startId }} - {{ endId }} of {{ dataCount }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'table-pagination-v2',
    props: {
      filteredData: {
        type: Array
      },
      dataCount: {
        type: Number
      },
      pages: {
        type: Number
      },
      pageNo: {
        type: Number
      },
      perPage: {
        type: Number
      },
      perPageChange: {
        type: Function
      },
      onChangePage: {
        type: Function
      },
      onNextPage: {
        type: Function
      },
      onPreviousPage: {
        type: Function
      },
      onFirstPage: {
        type: Function
      },
      onLastPage: {
        type: Function
      }
    },
    computed: {
      startNo () {
        return (this.pageNo - 1) * this.perPage
      },
      endNo () {
        return this.pageNo * this.perPage
      },
      pageStart () {
        if (this.$mq === 'mobile') {
          return this.pageNo
        } else if (this.$mq === 'tablet') {
          if (this.pageNo === 1 || this.pageNo <= 2 || this.pages <= 3) {
            return 1
          } else if (this.pageNo >= (this.pages - 1)) {
            return this.pages - 2
          }
          return this.pageNo - 1
        } else {
          if (this.pageNo === 1 || this.pageNo <= 2 || this.pages <= 5) {
            return 1
          } else if (this.pageNo >= (this.pages - 2)) {
            return this.pages - 4
          }
          return this.pageNo - 2
        }
      },
      pageEnd () {
        if (this.$mq === 'mobile') {
          return this.pageStart
        } else if (this.$mq === 'tablet') {
          return this.pageStart + 2 > this.pages ? this.pages : this.pageStart + 2
        } else {
          return this.pageStart + 4 > this.pages ? this.pages : this.pageStart + 4
        }
      },
      startId () {
        return this.perPage * (this.pageNo - 1) + 1
      },
      endId () {
        return (this.perPage * this.pageNo) < this.dataCount ? this.perPage * this.pageNo : this.dataCount
      }
    },
    data: function () {
      return {}
    },
    methods: {
      isCurrentPage (n) {
        return this.pageNo === n
      },
      range: function (min, max) {
        var array = []
        var j = 0
        for (var i = min; i <= max; i++) {
          array[j] = i
          j++
        }
        return array
      }
    }
  }
</script>
<style lang="scss">
  @import "../../../../sass/variables";

  th.active{
  color: $fractel-teal;
  }

  th.active .arrow {
  opacity: 1;
  }

  .arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0;
  }

  .arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
  }

  .arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
  }

  .search-input {
    border: 1px solid black;
    border-radius: 5px;
  }

  .pagination-input {
    margin-left: 0.5rem;
    border: 0.1rem solid black;
    border-radius: 0.5rem;
    max-width: 3.5rem;
    line-height: 3rem;
    text-align: center;
  }

  .pagination-status {
    margin-left: 2.5rem;
    max-width: 9.0rem;
    line-height: 3.5rem;
    text-align: center;
    font-weight: 500;
  }

  /* Vuestic Widget */
  .widget {
    background: $widget-bg;
    box-shadow: $widget-box-shadow;
    margin-bottom: $widget-mb;
    padding: 0;

    &.no-header {
      .widget-body {
        height: $widget-body-no-header-height;
      }
    }

    &.larger-padding {
      .widget-body {
        padding: $widget-larger-padding;
      }
    }

    &.no-h-padding {
      .widget-body {
        padding-left: 0;
        padding-right: 0;
      }
    }

    &.no-v-padding {
      .widget-body {
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    &.brand-info {
      background-color: $brand-info;
      color: $white;
      box-shadow: $widget-info-shadow;
    }

    &.brand-danger {
      background-color: $brand-danger;
      color: $white;
      box-shadow: $widget-danger-shadow;
    }

    &.info-widget {
      border-top: $info-widget-border;

      &.brand-info {
        border-top-color: $brand-info;
      }

      &.brand-danger {
        border-top-color: $brand-danger;
      }
    }

    .widget-body {
      height: $widget-body-with-header-height;
      padding: $widget-padding;
    }

    .widget-header {
      height: $widget-header-height;
      padding: 0 $widget-padding;
      border-bottom: $widget-header-border;
      font-size: $font-size-larger;
      font-weight: 600;
      display: flex;
      align-items: center;
    }
  }

  .clear-filter:hover {
    color: $fractel-teal;
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/fractel/components/objects/table/PaginationV2.vue